app.controller('CIF3-CTRL', ['$scope', '$window', '$q', '$filter', 'appFactory', '$uibModal',
    function ($scope, $window, $q, $filter, appFactory, $uibModal) {

    $scope.CIFInvestor = {}
    $scope.chkquestionfatca = true;
    $scope.chkquestion1 = false;
    $scope.chkquestion2 = false;
    $scope.chkquestion3 = false;
    $scope.chkquestion4 = false;


    $scope.validateAgreementFATCA = function () {
            if (!$scope.agree3) {

                $scope.disclaimerFATCA = false;
                $scope.showAgreement(1);
            }
    }

    $scope.showAgreement = function (number) {

        let htmlName = 'template/FATCAagereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'BCAAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {

                agreementNumber: function () {

                    return number;
                }
            }
        });

        modalInstance.result.then(function (response, agree) {

            if (response == 'accept') {

                if (number == 1) {

                    $scope.agree1 = true;
                    $scope.disclaimerFATCA = true;
                }

            }
        }, function () { });
    };

    var allPromise = $q.all([

        appFactory.getData(`service/client.svc/GetCIFLookup`).then(function (data) {

            if (data.status == 200) {
                
                $scope.ListLookup = data.data.d;

                if ($scope.ListLookup) {

                    $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
                    $scope.ListRisk = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Risk' }, true);
                }
            }
        }),

        $scope.retrieveSessions()
    ]);

    allPromise.then(function () {

        appFactory.getData(`service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 3;

                    if ($scope.CIFInvestor.FATCA1 == 'Ya' || $scope.CIFInvestor.FATCA2 == 'Ya' || $scope.CIFInvestor.FATCA3 == 'Ya')
                        $scope.chkquestionfatca = false;

                    if ($scope.CIFInvestor.InvestmentObjectives == 0)
                        $scope.CIFInvestor.InvestmentObjectives = '';
                }
            }
        });
    });

    $scope.prepareData = function () {

        if ($scope.chkquestion1) {

            if ($scope.chkquestion1 = true) {

                $scope.CIFInvestor.Question1 = 'Ya';
                $scope.CIFInvestor.Question1_Text = '';
            }
        }

        if ($scope.chkquestion2) {

            if ($scope.chkquestion2 = true) {

                $scope.CIFInvestor.Question2 = 'Ya';
                $scope.CIFInvestor.Question2_Text = '';
            }
        }

        if ($scope.chkquestion3) {

            if ($scope.chkquestion1 = true) {

                $scope.CIFInvestor.Question3 = 'Ya';
                $scope.CIFInvestor.Question3_Text = '';
            }
        }

        if ($scope.chkquestion4) {

            if ($scope.chkquestion4 = true) {

                $scope.CIFInvestor.Question4 = 'Ya';
                $scope.CIFInvestor.Question4_Text = '';
            }
        }

        if ($scope.chkquestion5) {

            if ($scope.chkquestion5 = true) {

                $scope.CIFInvestor.Question5 = 'Ya';
                $scope.CIFInvestor.Question5_Text = '';
            }
        }

        if ($scope.chkquestion6) {

            if ($scope.chkquestion6 = true) {

                $scope.CIFInvestor.Question6 = 'Ya';
                $scope.CIFInvestor.Question6_Text = '';
            }
        }

        if ($scope.chkquestionfatca) {

            if ($scope.chkquestionfatca = true) {

                $scope.CIFInvestor.FATCA1 = 'Tidak';
                $scope.CIFInvestor.FATCA2 = 'Tidak';
                $scope.CIFInvestor.FATCA3 = 'Tidak';
            }
        }
    }

    $scope.submit = function () {
        $scope.prepareData();

        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = 'service/client.svc/SaveCIF'; // 1
        var postData = { cifdata: $scope.CIFInvestor } // 2
        var preconfirmtranslate = "submitCif3"; // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/cif/data-pernyataan";
        });
    }

    $scope.validationinput = function () {

        if ($scope.CIFInvestor.FATCA1 != null                         //Jika Bukan WNI
            && $scope.CIFInvestor.FATCA2 != null
            && $scope.CIFInvestor.FATCA3 != null
            && ($scope.CIFInvestor.InvestmentObjectives != null || $scope.CIFInvestor.InvestmentObjectives != 0)  //Profil Resiko
            && $scope.CIFInvestor.Risk != null
            && $scope.CIFInvestor.Question1 != null
            && $scope.CIFInvestor.Question1_Text != null
            && $scope.CIFInvestor.Question2 != null
            && $scope.CIFInvestor.Question2_Text != null
            && $scope.CIFInvestor.Question3 != null
            && $scope.CIFInvestor.Question3_Text != null
            && $scope.CIFInvestor.Question4 != null
            && $scope.CIFInvestor.Question4_Text != null
            && $scope.CIFInvestor.Question5 != null         
            && $scope.CIFInvestor.Question5_Text != null
            && $scope.CIFInvestor.Question6 != null
            && $scope.CIFInvestor.Question6_Text != null)
        {
            console.log('validation success');
        }
        else {
            var SWALtranslate = $scope.SWALtranslate('validationinput');

            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }
    }
}]);


